<template>
    <div id='app-root'>
        <v-app>
            <div v-if="isApplicationReady">
                <!-- Toolbar. -->
                <go-nav />

                <!-- Contenu des pages de l'application. -->
                <v-content>
                    <v-container fluid>
                        <router-view></router-view>
                    </v-container>
                </v-content>

                <!-- Affichage automatique des messages retournés depuis le back. -->
                <go-affichage-messages/>
            </div>
            <go-template-pos></go-template-pos>
            <go-signer-cgu v-if="shouldSignCgu === true"></go-signer-cgu>
            <go-notification-pos v-if="dateNotificationPos" :date="dateNotificationPos"></go-notification-pos>
        </v-app>
    </div>
</template>

<script lang="ts">
    // Librairies importées.
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { Action, Getter } from 'vuex-class';
    import { HttpClient } from '@/shared/HttpClient';

    // Stores.
    import { MessageStoreMethods } from '@/store/MessageStore';
    import { SecurityStoreMethods } from '@/store/security/SecurityStore';

    // Composants.
    import NavMenu from '@/components/app/nav-menu/NavMenu.vue';
    import SignerCguPopupComponent from '@/components/administration/cgu/SignerCguPopup.vue';
    import NotificationPosPopupComponent from '@/components/administration/notification-pos/NotificationPosPopup.vue'
    
    import TemplatePos from '@/components/administration/templatePos/TemplatePosPopUp.vue'
    import AffichageMessages from '@/components/app/affichage-messages/AffichageMessages.vue';
    import { AxiosResponse } from 'axios';

    /** Composant principal de l'application Vue.js */
    @Component({
        components: {
            'go-nav': NavMenu,
            'go-affichage-messages': AffichageMessages,
            'go-signer-cgu': SignerCguPopupComponent,
            'go-notification-pos': NotificationPosPopupComponent,
            'go-template-pos': TemplatePos
        }
    })
    export default class App extends Vue {
        /**
         * Booléen correspondant au statut de lancement de l'application.
         */
        public isApplicationReady: boolean = false;

        /**
         *  Définie si l'utilisateur courant a signé les CGU.
         */
        @Getter(SecurityStoreMethods.GET_USERSHOULDSIGNCGU)
        public shouldSignCgu: boolean;

        @Getter(SecurityStoreMethods.GET_DATE_NOTIFICATION_POS)
        public dateNotificationPos: string;

        /**
         * Initialisation de l'intercepteur Axios.
         */
        @Action(MessageStoreMethods.SETUP_AXIOS_INTERCEPTOR)
        private setupAxiosInterceptor: () => AxiosResponse<any>;

        public async created() {
            // Lecture de l'URL de la Web API et configuration d'axios.
            HttpClient.init().then((response) => {

                this.isApplicationReady = response;

                // Initialisation de l'intercepteur Axios.
                this.setupAxiosInterceptor();
            });
        }
    }
</script>
